export enum PaymentTerm {
  Arrears = 0,
  Advance = 1,
}

export enum PaymentFrequency {
  Monthly = 12,
  Fortnightly = 26,
  Weekly = 52,
}

export const PAYMENT_FREQUENCY_SINGULAR_NAME = {
  [PaymentFrequency.Monthly]: 'Month',
  [PaymentFrequency.Fortnightly]: 'Fortnight',
  [PaymentFrequency.Weekly]: 'Week',
};

export const PAYMENT_FREQUENCY_ADJECTIVE = {
  [PaymentFrequency.Monthly]: 'monthly',
  [PaymentFrequency.Fortnightly]: 'fortnightly',
  [PaymentFrequency.Weekly]: 'weekly',
};
